import { BaseFieldProps, Field, WrappedFieldProps } from 'redux-form';
import { Dropzone } from '@mews-commander/ui';
import { DropzoneProps } from '@optimus-web/core';
import { getError } from '../../utils';

const WrappedDropzone: React.FC<WrappedFieldProps & DropzoneProps> = ({
    input: { value, onChange: inputOnChange },
    meta,
    onChange,
    ...others
}) => {
    const handleChange = (
        event: React.ChangeEvent<HTMLInputElement> | React.DragEvent<HTMLDivElement> | null,
        inputValue: File[] | null
    ) => {
        inputOnChange(inputValue);
        if (onChange) {
            onChange(event, value);
        }
    };

    return <Dropzone {...others} value={value} error={getError(meta)} onChange={handleChange} />;
};

export const DropzoneField = (
    props: BaseFieldProps<DropzoneProps> & Omit<DropzoneProps, 'value' | 'error' | 'onChange'>
) => <Field component={WrappedDropzone} props={{ name: props.name }} {...props} />;
